import { Editor } from '@tiptap/core';
import EditorCache from '../editorcache';
import { serializer } from '../wikitext';

export const setEditor = (editorid: string, editor: Editor) => {
   EditorCache.set(editorid, editor);
};

export const getEditor = (editorid: string): Editor => {
   return EditorCache.get(editorid);
};

export const getSerializedText = (editorid: string): string => {
   const editor = getEditor(editorid);
   const doc = editor && editor.state && editor.state.doc;
   return doc ? serializer.serialize(doc) : '';
};

export const getText = (editorid: string): string => {
   const editor = getEditor(editorid);
   return editor && editor.getText();
};

export const focusEditor = (editorid: string) => {
   const editor = getEditor(editorid);
   editor && editor.commands.focus();
};

export const clearContent = (editorid: string) => {
   const editor = getEditor(editorid);
   if (editor) {
      editor.commands.clearContent();
      editor.commands.updateSavedContent();
   }
};

export const resetContent = (editorid: string) => {
   const editor = getEditor(editorid);
   if (editor) {
      editor.commands.setContent(editor.storage.originalState.savedContent.toJSON());
   }
};

export const saveState = (editorid: string) => {
   const editor = getEditor(editorid);
   if (editor) {
      editor.commands.updateSavedContent();
   }
};

export const clearSessionStorage = (editorid: string) => {
   const editor = getEditor(editorid);
   editor && editor.commands.clearSessionStorage();
};

export const getCharacterCount = (editorid: string) => {
   const editor = getEditor(editorid);
   return editor && editor.storage.characterCount.characters();
};

export const clearError = (editorid: string) => {
   const editor = getEditor(editorid);
   editor && editor.commands.clearError();
};

export const hasUnsavedChanges = (editorid: string) => {
   const editor = getEditor(editorid);
   return editor?.storage.originalState.hasUnsavedChanges;
};
